import { useMemo } from "react";

import { TraxPageHeader } from "~/shared/components/trax-page-header/trax-page-header.tsx";
import { TraxPageLayout } from "~/shared/components/trax-page-layout/trax-page-layout.tsx";

import { AutoDispatchGrid } from "../components/grid/index.tsx";
import { useGetGlobalAccessorials } from "../hooks/use-get-carrier-accessorials.ts";
import { useGetColumns } from "../hooks/use-get-columns.tsx";
import { useGetGlobalCarriers } from "../hooks/use-get-global-carriers.ts";
import { useUpdateCarrier } from "../hooks/use-update-global-carriers.ts";
import { autoDispatchGridSection } from "./index.module.css";

export const GlobalLayout = () => {
	const updateCarrier = useUpdateCarrier();

	const { globalCarriers, globalCarriersIsLoading } = useGetGlobalCarriers();
	const { globalAccessorials, isLoading: accessorialsLoading } =
		useGetGlobalAccessorials();

	const columns = useGetColumns({
		isLoading: globalCarriersIsLoading || accessorialsLoading,
		updateCarrier,
		isCustomerGrid: false,
		globalAccessorials,
	});

	const memoizedColumns = useMemo(
		() => columns.filter((col) => col.group.includes("global")),
		[columns],
	);

	// Default the grid to alphabetical order by carrier name so users always
	// land on a predictable view. Users can still re-sort via column headers.
	const sortedCarriers = useMemo(
		() =>
			[...(globalCarriers ?? [])].sort((a, b) =>
				(a.carrierName ?? "").localeCompare(b.carrierName ?? ""),
			),
		[globalCarriers],
	);

	return (
		<TraxPageLayout>
			<TraxPageHeader title={"Auto Dispatch Admin"} />

			<div className={autoDispatchGridSection}>
				<AutoDispatchGrid
					columns={memoizedColumns}
					data={sortedCarriers}
					isLoading={globalCarriersIsLoading || accessorialsLoading}
				/>
			</div>
		</TraxPageLayout>
	);
};
